import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";
// import { initEventCardScrollEffects } from "./scroll/event-card-scroll-effects";
import { initCascadeScene } from "./scroll/cascade-scene";
gsap.registerPlugin(ScrollTrigger);

let lenis = null;

// theme modules
// import { statCounter } from "./text-anim.js";

// Initialize Lenis
if (!document.querySelector("body.wp-admin")) {
	lenis = new Lenis({
		autoRaf: true,
		// turn down the scroll a lot
		lerp: 0.3,
	});

	window.lenis = lenis;
}

export const initScroll = () => {
	if (!lenis) return;

	// const updateEventCardScrollEffects = initEventCardScrollEffects(lenis);
	initCascadeScene();
	applyScrollAnimations(200);

	lenis.on("scroll", (e) => {
		applyScrollAnimations(e.scroll);
		// updateEventCardScrollEffects(e);
		ScrollTrigger.update();
	});
	window.addEventListener("load", () => ScrollTrigger.refresh());
};

const applyScrollAnimations = (scroll) => {
	const elements = document.querySelectorAll("[data-scroll]");
	elements.forEach((el) => {
		checkAnimNameAndTrigger(el, scroll);
	});
};

// const checkAnimNameAndTrigger = (func, direct, obj) => {
const checkAnimNameAndTrigger = (el, scroll) => {
	// if it has speed, there needs to be a parallax effect
	if (el.hasAttribute("data-scroll-speed") && window.innerWidth > 768) {
		applyParallax(el, scroll);
	}

	// if it has an animation, trigger it
	if (el.hasAttribute("data-scroll-call")) {
		const func = el.getAttribute("data-scroll-call");
		const obj = {
			el: el,
		};
		if (!callAnimMap[func]) return;
		let triggerValue = el.getBoundingClientRect().top + window.scrollY;
		// let triggerValue = el.offsetTop;
		if (el.hasAttribute("data-scroll-offset")) {
			triggerValue += parseInt(el.getAttribute("data-scroll-offset"));
		}

		if (!el.hasAttribute("data-scroll-triggered") && triggerValue < window.innerHeight + window.scrollY) {
			// console.log("Calling ", func, " on ", el);
			callAnimMap[func](obj);
			el.setAttribute("data-scroll-triggered", true);
		}
	}
};

const applyParallax = (el, scroll) => {
	let triggerValue = el.getBoundingClientRect().top + window.scrollY;
	const sensitivity = 0.5;
	const speed = el.getAttribute("data-scroll-speed");
	const offset = el.getAttribute("data-scroll-offset") * sensitivity || 0;

	// Calculate relative scroll position from element's initial position
	const elementInitialPos = el.getBoundingClientRect().top + window.scrollY;
	const scrollFromElement = scroll - elementInitialPos;

	const scrollSpeedSensitivity = sensitivity / 10;
	const speedTranslateValue = scrollFromElement * speed * scrollSpeedSensitivity * -1 + offset;

	const isInView =
		triggerValue < window.scrollY + window.innerHeight + offset &&
		triggerValue > window.scrollY - window.innerHeight - offset;

	if (isInView) {
		el.style.transform = `translateY(${speedTranslateValue}px)`;
	}
};

export const fadeIn = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("fade-in");
};

export const fadeUp = (obj) => {
	console.log("fading up");
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("fade-up");
};

export const fadeLeft = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("fade-left");
};

export const fadeRight = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("fade-right");
};

export const fadeDown = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("fade-down");
};

export const slideLeft = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("slide-left");
};

export const slideRight = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("slide-right");
};

export const highlightLeft = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("highlight-left");
};

export const highlightRight = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("highlight-right");
};

const expandRight = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transformOrigin = "left";
	// obj.el.style.transitionDelay = `${delay}ms`;
	// obj.el.classList.add("expand-right");
	gsap.fromTo(obj.el, { scaleX: 0 }, { scaleX: 1, duration: 0.5 });
};

const flipUp = (obj) => {
	if (obj.el.classList.contains("flip-up")) return;
	const delay = obj.el.dataset.scrollDelay || 0;

	obj.el.classList.add("flip-up");
	const tl = gsap.timeline();

	const wrap = obj.el.parentElement;
	gsap.set(wrap, { perspective: 800 }); //This is the key

	tl.fromTo(
		obj.el,
		{ translateY: 10, rotationX: -18, opacity: 0 },
		{ translateY: 0, rotationX: 0, opacity: 1, duration: 0.5, delay: delay / 1000 },
	);
};

const flipRight = (obj) => {
	if (obj.el.classList.contains("flip-right")) return;
	const delay = obj.el.dataset.scrollDelay || 0;

	obj.el.classList.add("flip-right");
	const tl = gsap.timeline();

	const wrap = obj.el.parentElement;
	gsap.set(wrap, { perspective: 800 }); //This is the key

	tl.fromTo(
		obj.el,
		{ translateX: 10, rotationY: -18, opacity: 0 },
		{ translateX: 0, rotationY: 0, opacity: 1, duration: 0.5, delay: delay / 1000 },
	);
};

const flipLeft = (obj) => {
	if (obj.el.classList.contains("flip-left")) return;
	const delay = obj.el.dataset.scrollDelay || 0;

	obj.el.classList.add("flip-left");
	const tl = gsap.timeline();

	const wrap = obj.el.parentElement;
	gsap.set(wrap, { perspective: 800 }); //This is the key

	tl.fromTo(
		obj.el,
		{ translateX: -10, rotationY: 18, opacity: 0 },
		{ translateX: 0, rotationY: 0, opacity: 1, duration: 0.5, delay: delay / 1000 },
	);
};

const flipDown = (obj) => {
	if (obj.el.classList.contains("flip-down")) return;
	const delay = obj.el.dataset.scrollDelay || 0;

	obj.el.classList.add("flip-down");
	const tl = gsap.timeline();

	const wrap = obj.el.parentElement;
	gsap.set(wrap, { perspective: 800 }); //This is the key

	tl.fromTo(
		obj.el,
		{ translateY: -10, rotationX: 18, opacity: 0 },
		{ translateY: 0, rotationX: 0, opacity: 1, duration: 0.5, delay: delay / 1000 },
	);
};

const rotateClockwise = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;

	obj.el.classList.add("rotate-clockwise");
	const tl = gsap.timeline();

	tl.fromTo(
		obj.el,
		{ rotate: -15, x: -30, y: 45, opacity: 0 },
		{ rotate: 0, x: 0, y: 0, opacity: 1, duration: 0.5, delay: delay / 1000 },
	);
};

const rotateCounterClockwise = (obj) => {
	const delay = obj.el.dataset.scrollDelay || 0;

	obj.el.classList.add("rotate-counter-clockwise");
	const tl = gsap.timeline();

	tl.fromTo(
		obj.el,
		{ rotate: 60, x: 5, y: 20, opacity: 0 },
		{ rotate: 0, x: 0, y: 0, opacity: 1, duration: 0.5, delay: delay / 1000 },
	);
};

const callAnimMap = {
	"fade-in": fadeIn,
	"fade-up": fadeUp,
	"fade-left": fadeLeft,
	"fade-right": fadeRight,
	"fade-down": fadeDown,
	"slide-left": slideLeft,
	"slide-right": slideRight,
	"flip-up": flipUp,
	"flip-right": flipRight,
	"flip-left": flipLeft,
	"flip-down": flipDown,
	"rotate-clockwise": rotateClockwise,
	"rotate-counter-clockwise": rotateCounterClockwise,
	"highlight-left": highlightLeft,
	"highlight-right": highlightRight,
	// "stat-counter": statCounter,
	"expand-right": expandRight,
};
